<template>
  <div class="heatmap_type"
       :style="{ width: widthProp }">
<!--    <div class="legend" v-if="eventType === 'tap'">-->
<!--        <span class="tab">-->
<!--          <i class="icon icon&#45;&#45;heatmap-tap"></i> {{ $t('common.unit.tap') }}-->
<!--        </span>-->
<!--        <span class="tab">-->
<!--          <i class="icon icon&#45;&#45;heatmap-double-tap"></i> {{ $t('common.unit.doubleTap') }}-->
<!--        </span>-->
<!--    </div>-->
    <div class="choose" v-if="eventType === 'zoom'">
      <button class="tab"
              :class="{ active: heatmapType === 0 }"
              @click="setType(0)">
        <i class="icon icon--heatmap-zoom-in"></i> {{ $t('common.unit.zoomin') }}
      </button>
      <button class="tab"
              :class="{ active: heatmapType === 1 }"
              @click="setType(1)">
        <i class="icon icon--heatmap-zoom-out"></i> {{ $t('common.unit.zoomout') }}
      </button>
    </div>
    <div class="choose" v-else-if="eventType === 'swipe'">
      <button class="tab"
              :class="{ active: heatmapType === 0 }"
              @click="setType(0)">
        <i class="icon icon--heatmap-swipe-vertical"></i> {{ $t('common.unit.vertical') }}
      </button>
      <button class="tab"
              :class="{ active: heatmapType === 1 }"
              @click="setType(1)">
        <i class="icon icon--heatmap-swipe-horizontal"></i> {{ $t('common.unit.horizontal') }}
      </button>
    </div>
    <div class="click-group-btn-wrap" v-if="eventType === 'click' || eventType === 'tap'">
      <div
        class="toggle"
        :class="{ disabled: !isPlusPlan }"
        @mouseenter="onGroupingHover(true)"
        @mouseleave="onGroupingHover(false)">
        <span>Grouping</span>
        <ui-switch
          :on="isGroupingToggle"
          :onValue="' '"
          :offValue="' '"
          :disabled="!isPlusPlan"
          @click="onGroupingToggle($event)" />
        <ui-tooltip v-if="!isPlusPlan && isGroupHover"
                    class="group-plan-tooltip"
                    arrowTop arrowCenter>
          <p :class="$i18n.locale" v-html="$t('heatmap.groupingView.noPlusPlan')"></p>
          <a :href="tooltipLink" target="_blank">
            {{ $t('heatmap.cvr_exit.frequency.goLink') }}
            <i class="icon icon-link"></i>
          </a>
        </ui-tooltip>
      </div>
    </div>
    <div class="film-btn-wrap" v-if="onlyDefaultAndCompare"
         :style="{marginBottom: !isFilmToggle ? '20px' : '6px'}">
      <div
        class="toggle"
        :class="{ disabled: reportPeriod.start === reportPeriod.end || !isPlusPlan || !scrollData || isFilmMaximumPeriod }"
        @mouseenter="onFilmHover(true)"
        @mouseleave="onFilmHover(false)">
        <span>Filmstrip</span>
        <ui-switch
          :on="isFilmToggle"
          :onValue="' '"
          :offValue="' '"
          :disabled="reportPeriod.start === reportPeriod.end || !isPlusPlan || !scrollData || isFilmMaximumPeriod"
          @click="onFilmToggle($event)" />
        <ui-tooltip v-if="reportPeriod.start === reportPeriod.end && isFilmHover"
                    class="film-tooltip"
                    arrowTop arrowCenter>
          <p :class="$i18n.locale" v-html="$t('heatmap.filmStrip.oneDay')"></p>
        </ui-tooltip>
        <ui-tooltip v-if="!isPlusPlan && isFilmHover"
                    class="film-plan-tooltip"
                    arrowTop arrowCenter>
          <p :class="$i18n.locale" v-html="$t('heatmap.filmStrip.noPlusPlan')"></p>
          <a :href="tooltipLink" target="_blank">
            {{ $t('heatmap.cvr_exit.frequency.goLink') }}
            <i class="icon icon-link"></i>
          </a>
        </ui-tooltip>
        <ui-tooltip v-if="isPlusPlan && isFilmMaximumPeriod && isFilmHover"
                    class="film-plan-tooltip maximum-period"
                    arrowTop arrowCenter>
          <p :class="$i18n.locale" v-html="$t('heatmap.filmStrip.maximumPeriod')"></p>
        </ui-tooltip>
      </div>
      <template v-if="isFilmToggle">
        <div class="line"></div>
        <div class="check-box">
          <span
            class="ui_checkbox"
            :class="{ on: isAttention }"
            @click="onFilmAttention(!isAttention)">
            <i class="icon icon--chkbox"></i>
            <span class="text">Attention</span>
          </span>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { differenceInDays } from 'date-fns'
import UiTooltip from '@/components/ui/UiTooltip.vue'
import UiSwitch from '@/components/ui/UiSwitch.vue'

export default {
  name: 'HeatmapType',
  components: { UiSwitch, UiTooltip },
  props: [
    'eventType',
    'heatmapType',
    'isPlusPlan',
    'isGroupingToggle',
    'isGroupHover',
    'tooltipLink',
    'isFilmToggle',
    'isAttention',
    'onlyDefaultAndCompare',
    'reportPeriod',
    'isFilmHover',
    'scrollData'
  ],
  methods: {
    setType (value) {
      this.$emit('setHeatmapType', value)
    },
    onGroupingToggle (event) {
      this.$emit('groupingToggle', event)
    },
    onGroupingHover (isHover) {
      this.$emit('groupingHover', isHover)
    },
    onFilmToggle (event) {
      this.$emit('filmToggle', event)
    },
    onFilmAttention (value) {
      this.$emit('onFilmAttention', value)
    },
    onFilmHover (isHover) {
      this.$emit('onFilmHover', isHover)
    }
  },
  mounted () {
    console.log(this.eventType)
  },
  computed: {
    widthProp () {
      let scrollDiv = document.createElement('div')
      scrollDiv.style.overflow = 'scroll'
      document.body.appendChild(scrollDiv)
      let scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
      scrollDiv.remove()
      return `calc(100% - ${scrollbarWidth}px)`
    },
    isFilmMaximumPeriod () {
      return differenceInDays(this.reportPeriod.end, this.reportPeriod.start) + 1 > 31
    }
  }
}
</script>

<style lang="scss">
.heatmap_type {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 5;
  height: 41px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
  text-align: center;

  .icon {
    vertical-align: middle;
    transform: translateY(-1px);
  }

  .legend {
    .tab {
      display: inline-block;
      line-height: 26px;
      height: 26px;
      margin: 8px 10px;
      color: #ffffff;
    }
  }

  .choose {
    display: inline-block;
    border-radius: 5px;
    border: solid 1px rgba(255, 255, 255, 0.1);
    background-color: rgba(0, 0, 0, 0.4);
    height: 26px;
    margin: 8px 0;
    padding: 0;

    .tab {
      display: inline-block;
      line-height: 26px;
      height: 26px;
      margin: 0;
      padding: 0 10px 0 7px;
      color: #ffffff;
      opacity: 0.3;

      &.active {
        opacity: 1;
        border-radius: 5px;
        background-color: #ec0047;
      }
    }
  }

  .click-group-btn-wrap {
    padding: 9px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    margin-bottom: 20px;

    .toggle {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      color: #FFF;
      text-align: right;
      font-size: 12px;
      font-weight: 500;

      &.disabled {
        cursor: initial;
      }

      button {
        background-color: #555;

        .circle {
          background-color: #bbb;
        }

        &.on {
          background-color: #64b950;

          .circle {
            background-color: #fff;
          }
        }

      }
    }

    .group-plan-tooltip {
      max-width: 326px;
      top: 107%;
      left: 400px;
      transform: translate(-50%, 0);

      .text {
        p {
          max-width: 286px;
          text-align: left;
          margin-bottom: 10px;
          white-space: normal;
          word-break: break-word;

          &.ja {
            word-break: break-all;
          }
        }
        a {
          display: flex;
          font-size: 13px;
          font-weight: 400;
          color: #0074FF;
          text-decoration: none;
          margin-top: 10px;
          i.icon-link {
            width: 16px;
            height: 16px;
            background: url('../../assets/img/icon_link_blue_size16.svg') no-repeat center center;
            background-size: cover;
            transform: scaleX(-1);
            margin-left: 5px;
          }
        }
      }
    }
  }

  .film-btn-wrap {
    padding: 9px 0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;

    .toggle {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      cursor: pointer;
      color: #FFF;
      text-align: right;
      font-size: 12px;
      font-weight: 500;

      &.disabled {
        cursor: initial;
      }

      button {
        background-color: #555;

        .circle {
          background-color: #bbb;
        }

        &.on {
          background-color: #64b950;

          .circle {
            background-color: #fff;
          }
        }

      }
    }

    .line {
      width: 1px;
      height: 15px;
      background-color: #555;
      margin: 0 10px;
    }

    .check-box {
      .ui_checkbox {
        display: flex;
        align-items: center;
        margin: 0;

        .icon {
          transform: translateY(-50%);
        }

        &.on > .icon--chkbox {
          width: 18px;
          height: 18px;
          background-image: url(../../assets/img/icon_chkbox_on.svg);
          transform: translateY(-50%);
        }
        .text {
          font-size: 12px;
          color: #D7D7D7;
        }
      }
    }

    .film-plan-tooltip {
      max-width: 326px;
      top: 107%;
      left: 396px;
      transform: translate(-50%, 0);

      &.maximum-period {
        .text {
          p {
            word-break: keep-all;
            white-space: normal;
            margin-bottom: 0;
          }
        }
      }

      .text {
        p {
          max-width: 286px;
          text-align: left;
          margin-bottom: 10px;
          white-space: normal;
          word-break: break-word;

          &.ja {
            word-break: break-all;
          }
        }
        a {
          display: flex;
          font-size: 13px;
          font-weight: 400;
          color: #0074FF;
          text-decoration: none;
          margin-top: 10px;
          i.icon-link {
            width: 16px;
            height: 16px;
            background: url('../../assets/img/icon_link_blue_size16.svg') no-repeat center center;
            background-size: cover;
            transform: scaleX(-1);
            margin-left: 5px;
          }
        }
      }
    }
    .film-tooltip {
      max-width: 300px;
      position: absolute;
      top: 107%;
      left: 55%;
      transform: translate(-50%, 0);
      padding: 21px;

      .text {
        white-space: normal;
        word-break: break-word;
        text-align: left;
      }
    }
  }
}
</style>
